export const oidcConfig = {
    authority: 'https://lemur-15.cloud-iam.com/auth/realms/medlog',
    client_id: 'medlog_web',
    redirect_uri: 'http://localhost:3000/callback',
    issuer: 'https://lemur-15.cloud-iam.com/auth',
    scope: 'openid profile email',
};
